import { DeleteCenterProgramRequest } from '../../../lib/types/models/center/center'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const deleteCenterActivity = async (input: DeleteCenterProgramRequest) => {
  const { id, centerId } = input
  return restApiClient
    .url(constructApiUrl(API.centers.deleteCenterActivity.url, { centerId, centerActivityId: id }))
    .delete()
}
